import { number, oneOf, string } from 'prop-types';

import { useStatusColor } from '../../utilities/ColorUtilities';
import { orderedStatuses } from '../../utilities/StatusUtilities';

const statusColors = orderedStatuses.map((status) => status.value);

export default function StatusBlock({ color, size, className }) {
    const statusColor = useStatusColor(color);

    if (!statusColor) return null;
    return (
        <svg className={className} width={size} height={size} viewBox="0 0 100 100">
            <rect x="0" y="0" width="100" height="100" style={{ fill: statusColor }} />
        </svg>
    );
}

StatusBlock.propTypes = {
    color: oneOf(statusColors).isRequired,
    size: number,
    className: string,
};

StatusBlock.defaultProps = {
    size: 16,
    className: undefined,
};
